import { recursosDoModulo } from '../components/modulo-resumo/recursos-modulos.catalogo';
import { ResultadoBusca, TipoResultadoBusca } from './busca-global.model';

interface PaginaIndexada {
  titulo: string;
  descricao: string;
  modulo: string;
  icone: string;
  rota: string;
  termos?: string[];
}

const PAGINAS_INDEXADAS: PaginaIndexada[] = [
  {
    titulo: 'Home do administrativo',
    descricao: 'Painel inicial com os módulos e permissões liberados para a entidade.',
    modulo: 'Administração',
    icone: 'house',
    rota: '/adm/home',
    termos: ['início', 'painel', 'dashboard', 'módulos']
  },
  {
    titulo: 'Permissões PNCP',
    descricao: 'Entidades habilitadas e credenciais da integração com o PNCP.',
    modulo: 'PNCP',
    icone: 'key-round',
    rota: '/adm/pncp/permissoesPncp',
    termos: ['contratações públicas', 'integração', 'credenciais']
  },
  {
    titulo: 'Dados PNCP',
    descricao: 'Contratações enviadas ao Portal Nacional de Contratações Públicas.',
    modulo: 'PNCP',
    icone: 'file-text',
    rota: '/adm/pncp/dados-pncp',
    termos: ['contratos', 'licitações', 'envio']
  },
  {
    titulo: 'Licitações — Lei 14.133/21',
    descricao: 'Cadastro e acompanhamento das licitações e compras enviadas ao PNCP.',
    modulo: 'PNCP',
    icone: 'clipboard-list',
    rota: '/adm/pncp/contratacoes',
    termos: ['compra', 'licitação', 'processo', 'publicação', 'pncp', '14.133']
  },
  {
    titulo: 'Intenções de Registro de Preços',
    descricao: 'Cadastro, retificação e exclusão das IRPs gravadas no SAI e enviadas ao PNCP.',
    modulo: 'PNCP',
    icone: 'file-signature',
    rota: '/adm/pncp/intencoes-registro-preco',
    termos: ['irp', 'registro de preços', 'intenção', 'itens', 'documentos', 'pncp']
  },
  {
    titulo: 'Planos de Contratação Anual',
    descricao: 'Cadastro dos PCAs, itens por planilha e registros enviados ao PNCP.',
    modulo: 'PNCP',
    icone: 'calendar-range',
    rota: '/adm/pncp/planos-contratacao-anual',
    termos: ['pca', 'plano', 'contratação anual', 'planilha', 'itens', 'pncp']
  },
  {
    titulo: 'Licitações — Lei 8.666/93',
    descricao: 'Consulta das licitações cadastradas conforme a legislação anterior.',
    modulo: 'Licitações',
    icone: 'file-clock',
    rota: '/adm/licitacoes/home',
    termos: ['licitação', 'processo', 'edital', '8.666', 'licitações antigas']
  },
  {
    titulo: 'Dashboard de certificados',
    descricao: 'Visão geral dos certificados digitais e dos vencimentos próximos.',
    modulo: 'Certificados',
    icone: 'layout-dashboard',
    rota: '/adm/certificados/dashboard',
    termos: ['certificado digital', 'vencimento', 'indicadores']
  },
  {
    titulo: 'Sites ativos',
    descricao: 'Sites publicados pelas entidades e o certificado vinculado a cada um.',
    modulo: 'Certificados',
    icone: 'globe',
    rota: '/adm/certificados/sites-ativos',
    termos: ['domínio', 'https', 'portal']
  },
  {
    titulo: 'Gerenciamento de certificados',
    descricao: 'Upload, substituição e situação dos certificados por entidade.',
    modulo: 'Certificados',
    icone: 'sliders-horizontal',
    rota: '/adm/certificados/certificados-gerenciamento',
    termos: ['a1', 'a3', 'upload', 'renovação']
  },
  {
    titulo: 'Migração de dados',
    descricao: 'Lotes de carga enviados ao sistema e a situação de cada processamento.',
    modulo: 'Migração de Dados',
    icone: 'database',
    rota: '/adm/migracao-dados',
    termos: ['importação', 'carga', 'reprocessamento']
  },
  {
    titulo: 'Cadastro de clientes',
    descricao: 'Entidades administrativas atendidas pela plataforma.',
    modulo: 'Cadastros',
    icone: 'building-2',
    rota: '/adm/imap/cliente',
    termos: ['entidade', 'órgão', 'prefeitura', 'câmara']
  },
  {
    titulo: 'Gerenciador de módulos',
    descricao: 'Módulos do sistema, com rota, ordem de exibição e situação.',
    modulo: 'Cadastros',
    icone: 'blocks',
    rota: '/adm/imap/modulo',
    termos: ['menu', 'permissão', 'rota']
  },
  {
    titulo: 'Cadastro de usuários',
    descricao: 'Usuários do sistema, perfis de acesso, grupos e trilha de auditoria.',
    modulo: 'Cadastros',
    icone: 'users',
    rota: '/adm/imap/usuario',
    termos: ['acesso', 'login', 'permissão']
  },
  {
    titulo: 'Usuários cadastrados',
    descricao: 'Lista de usuários com perfil, entidade vinculada e situação.',
    modulo: 'Cadastros',
    icone: 'user-plus',
    rota: '/adm/imap/usuario/cadastro',
    termos: ['novo usuário', 'senha', 'e-mail']
  },
  {
    titulo: 'Perfis de acesso',
    descricao: 'Perfis cadastrados e as permissões por módulo e por tela.',
    modulo: 'Cadastros',
    icone: 'shield-check',
    rota: '/adm/imap/usuario/perfis',
    termos: ['permissão', 'papel', 'administrador']
  },
  {
    titulo: 'Grupos cadastrados',
    descricao: 'Grupos de entidades e a composição de cada um.',
    modulo: 'Cadastros',
    icone: 'users-round',
    rota: '/adm/imap/usuario/grupos',
    termos: ['agrupamento', 'entidades']
  },
  {
    titulo: 'Logs de acesso',
    descricao: 'Trilha de auditoria com data, hora, IP e ação realizada.',
    modulo: 'Cadastros',
    icone: 'scroll-text',
    rota: '/adm/imap/usuario/logs',
    termos: ['auditoria', 'sessão', 'tentativa de acesso']
  },
  {
    titulo: 'Módulos da carta de serviços',
    descricao: 'Painel com todos os módulos do portal público da carta de serviços.',
    modulo: 'Carta de Serviços',
    icone: 'layout-grid',
    rota: '/adm/carta-servicos/imap/modulo-carta-servicos',
    termos: ['portal do cidadão', 'hub']
  },
  {
    titulo: 'Módulos do site institucional',
    descricao: 'Painel com os módulos do portal institucional da Prefeitura, Câmara ou Consórcio.',
    modulo: 'Institucional',
    icone: 'globe',
    rota: '/adm/institucional',
    termos: ['portal institucional', 'prefeitura', 'câmara', 'consórcio', 'hub']
  },
  {
    titulo: 'Serviços',
    descricao: 'Categorias e serviços publicados no portal do cidadão.',
    modulo: 'Carta de Serviços',
    icone: 'list-checks',
    rota: '/adm/carta-servicos/servicos',
    termos: ['atendimento', 'protocolo', 'cidadão']
  },
  {
    titulo: 'Adicionar serviço',
    descricao: 'Cadastro do serviço em etapas: dados, requisitos, documentos e responsáveis.',
    modulo: 'Carta de Serviços',
    icone: 'plus',
    rota: '/adm/carta-servicos/servicos/adicionar-servico',
    termos: ['novo serviço', 'cadastro', 'etapas']
  },
  {
    titulo: 'Categorias de serviços',
    descricao: 'Categorias que organizam os serviços no portal.',
    modulo: 'Carta de Serviços',
    icone: 'folder',
    rota: '/adm/carta-servicos/categorias-servicos',
    termos: ['agrupamento', 'ícone', 'cor tema']
  },
  {
    titulo: 'Canais de atendimento',
    descricao: 'Canais publicados ao cidadão, com tipo, contato e situação.',
    modulo: 'Carta de Serviços',
    icone: 'headset',
    rota: '/adm/carta-servicos/canais-atendimento',
    termos: ['telefone', 'whatsapp', 'presencial', 'e-mail']
  },
  {
    titulo: 'Perguntas frequentes',
    descricao: 'Perguntas e respostas exibidas ao cidadão na carta de serviços.',
    modulo: 'Carta de Serviços',
    icone: 'circle-question-mark',
    rota: '/adm/carta-servicos/perguntas-frequentes',
    termos: ['faq', 'dúvidas', 'accordion']
  },
  {
    titulo: 'Política de atendimento ao cidadão',
    descricao: 'Compromissos e regras do atendimento publicados no portal.',
    modulo: 'Carta de Serviços',
    icone: 'file-text',
    rota: '/adm/carta-servicos/politica-atendimento',
    termos: ['compromisso', 'regras', 'prazo']
  },
  {
    titulo: 'LGPD e privacidade de dados',
    descricao: 'Encarregado de dados (DPO) e documentos de proteção de dados.',
    modulo: 'Carta de Serviços',
    icone: 'shield',
    rota: '/adm/carta-servicos/lgpd',
    termos: ['dpo', 'privacidade', 'proteção de dados', 'documentos']
  },
  {
    titulo: 'Métricas de atendimento',
    descricao: 'Indicadores, gráficos e relatórios dos atendimentos por canal.',
    modulo: 'Carta de Serviços',
    icone: 'chart-column',
    rota: '/adm/carta-servicos/metricas-atendimento',
    termos: ['relatório', 'sla', 'tempo médio', 'exportação']
  },
  {
    titulo: 'Notícias',
    descricao: 'Notícias publicadas, em revisão e em rascunho do portal.',
    modulo: 'Carta de Serviços',
    icone: 'newspaper',
    rota: '/adm/carta-servicos/noticias',
    termos: ['publicação', 'matéria', 'destaque']
  },
  {
    titulo: 'Cadastro de notícia',
    descricao: 'Cadastro em etapas com editor de texto, imagem de capa e seções.',
    modulo: 'Carta de Serviços',
    icone: 'plus',
    rota: '/adm/carta-servicos/noticias/cadastro',
    termos: ['nova notícia', 'agendamento']
  },
  {
    titulo: 'Links dinâmicos',
    descricao: 'Links exibidos no portal, com destino, local de exibição e situação.',
    modulo: 'Carta de Serviços',
    icone: 'link',
    rota: '/adm/carta-servicos/link-dinamico',
    termos: ['url', 'nova aba', 'modal']
  },
  {
    titulo: 'Gerenciamento da carta de serviço',
    descricao: 'Acompanhamento das cartas de serviço recebidas e das respostas.',
    modulo: 'Carta de Serviços',
    icone: 'clipboard-list',
    rota: '/adm/carta-servicos/gerenciamento-carta-servico',
    termos: ['carta', 'resposta', 'acompanhamento']
  },
  {
    titulo: 'Respostas das cartas de serviço',
    descricao: 'Cartas recebidas por categoria, prontas para resposta ao cidadão.',
    modulo: 'Carta de Serviços',
    icone: 'mail',
    rota: '/adm/carta-servicos/gerenciamento-carta-servico/resposta-carta-servico',
    termos: ['responder', 'categoria', 'cartas recebidas']
  },
  {
    titulo: 'Editor da home page',
    descricao: 'Editor dos blocos que formam a página inicial do portal.',
    modulo: 'Editor da Home Page',
    icone: 'layout-template',
    rota: '/adm/carta-servicos/editor-homepage',
    termos: ['site', 'página inicial', 'blocos']
  },
  {
    titulo: 'Cabeçalho do portal',
    descricao: 'Brasão, nome do ente e itens do menu exibidos no topo do portal.',
    modulo: 'Editor da Home Page',
    icone: 'panel-top',
    rota: '/adm/carta-servicos/editor-homepage/cabecalho',
    termos: ['menu', 'brasão', 'topo']
  },
  {
    titulo: 'Banner da home page',
    descricao: 'Banners publicados na página inicial, com recorte e cor predominante.',
    modulo: 'Editor da Home Page',
    icone: 'image',
    rota: '/adm/carta-servicos/editor-homepage/banner',
    termos: ['imagem', 'capa', 'destaque']
  },
  {
    titulo: 'Acesso rápido',
    descricao: 'Destaques de serviços rápidos exibidos na página inicial.',
    modulo: 'Editor da Home Page',
    icone: 'zap',
    rota: '/adm/carta-servicos/editor-homepage/acesso-rapido',
    termos: ['atalho', 'destaques', 'serviços rápidos']
  },
  {
    titulo: 'Redes sociais',
    descricao: 'Redes cadastradas com link, ícone, cor e ordem de exibição.',
    modulo: 'Editor da Home Page',
    icone: 'share-2',
    rota: '/adm/carta-servicos/editor-homepage/redes-sociais',
    termos: ['instagram', 'facebook', 'youtube']
  },
  {
    titulo: 'Rodapé do portal',
    descricao: 'Endereço, contatos e links de acesso rápido do rodapé.',
    modulo: 'Editor da Home Page',
    icone: 'panel-bottom',
    rota: '/adm/carta-servicos/editor-homepage/rodape',
    termos: ['contato', 'endereço', 'horário']
  },
  {
    titulo: 'Padrão de cores e ordenação',
    descricao: 'Tema de cor do portal e ordem dos blocos da página inicial.',
    modulo: 'Editor da Home Page',
    icone: 'palette',
    rota: '/adm/carta-servicos/editor-homepage/padrao-cores-ordenacao',
    termos: ['tema', 'paleta', 'ordem']
  },
  {
    titulo: 'e-SIC',
    descricao: 'Painel do Serviço de Informação ao Cidadão e seus submódulos.',
    modulo: 'e-SIC',
    icone: 'file-search',
    rota: '/adm/carta-servicos/sic',
    termos: ['lai', 'acesso à informação', 'transparência']
  },
  {
    titulo: 'Gerenciar e-SIC',
    descricao: 'Departamentos, áreas técnicas e responsáveis pelos pedidos.',
    modulo: 'e-SIC',
    icone: 'settings',
    rota: '/adm/carta-servicos/sic/gerenciar',
    termos: ['departamento', 'responsável', 'prazo interno']
  },
  {
    titulo: 'Manifestações do e-SIC',
    descricao: 'Pedidos recebidos, prazos, encaminhamentos e respostas.',
    modulo: 'e-SIC',
    icone: 'inbox',
    rota: '/adm/carta-servicos/sic/manifestacoes',
    termos: ['pedido', 'protocolo', 'prazo', 'recurso']
  },
  {
    titulo: 'Estatísticas do e-SIC',
    descricao: 'Evolução dos pedidos, desempenho por departamento e prazos críticos.',
    modulo: 'e-SIC',
    icone: 'chart-line',
    rota: '/adm/carta-servicos/sic/estatisticas',
    termos: ['gráfico', 'indicador', 'satisfação']
  },
  {
    titulo: 'Canal do e-SIC',
    descricao: 'Configuração do canal do e-SIC publicado ao cidadão.',
    modulo: 'e-SIC',
    icone: 'headset',
    rota: '/adm/carta-servicos/sic/canal-sic',
    termos: ['atendimento', 'canal', 'publicação']
  },
  {
    titulo: 'Ouvidoria',
    descricao: 'Painel da ouvidoria com ouvidorias, ouvidores e manifestações.',
    modulo: 'Ouvidoria',
    icone: 'megaphone',
    rota: '/adm/carta-servicos/ouvidoria',
    termos: ['denúncia', 'reclamação', 'elogio', 'sugestão']
  },
  {
    titulo: 'Ouvidorias cadastradas',
    descricao: 'Ouvidorias criadas, com município, órgão e responsável.',
    modulo: 'Ouvidoria',
    icone: 'building',
    rota: '/adm/carta-servicos/ouvidoria/cadastro-ouvidorias',
    termos: ['implantação', 'sla', 'prazo de resposta']
  },
  {
    titulo: 'Ouvidores',
    descricao: 'Ouvidores responsáveis, com órgão, perfil de acesso e situação.',
    modulo: 'Ouvidoria',
    icone: 'user-check',
    rota: '/adm/carta-servicos/ouvidoria/ouvidores',
    termos: ['responsável', 'nomeação', 'perfil']
  },
  {
    titulo: 'Manifestações da ouvidoria',
    descricao: 'Manifestações recebidas, com prazo, encaminhamento e resposta.',
    modulo: 'Ouvidoria',
    icone: 'message-square',
    rota: '/adm/carta-servicos/ouvidoria/manifestacoes',
    termos: ['protocolo', 'denúncia', 'reclamação', 'tramitação']
  },
  {
    titulo: 'Departamentos da ouvidoria',
    descricao: 'Departamentos que recebem as manifestações, com responsável padrão.',
    modulo: 'Ouvidoria',
    icone: 'network',
    rota: '/adm/carta-servicos/ouvidoria/departamentos',
    termos: ['setor', 'secretaria', 'responsável']
  },
  {
    titulo: 'Canal da ouvidoria',
    descricao: 'Configuração do canal da ouvidoria publicado ao cidadão.',
    modulo: 'Ouvidoria',
    icone: 'headset',
    rota: '/adm/carta-servicos/ouvidoria/canal-ouvidoria',
    termos: ['atendimento', 'canal', 'publicação']
  }
];

/**
 * As telas do sistema. Os registros (serviços, categorias, notícias, pedidos
 * e manifestações) vêm da API, pelo BuscaGlobalService.
 */
export const CATALOGO_BUSCA_GLOBAL: ResultadoBusca[] = PAGINAS_INDEXADAS.map((pagina, indice) => ({
  id: `pagina-${indice + 1}`,
  titulo: pagina.titulo,
  descricao: pagina.descricao,
  tipo: 'Página' as TipoResultadoBusca,
  modulo: pagina.modulo,
  icone: pagina.icone,
  rota: pagina.rota,
  termos: [...(pagina.termos ?? []), ...recursosDoModulo(pagina.rota)]
}));
